import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=b5394ffa&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports